import { useEffect, useState } from 'react';
import styles from './delete.module.scss';
import { DeleteBranchesProps } from '../../../../interfaces/components';
import { useToast } from '../../../../helpers/hooks';
import ButtonShared from '../../../../components/Button/Button';
import Modal from '../../../../components/Modal/Modal';
import { capitalize } from '../../../../helpers/app';

const Sidebar = ({
    user,
    open,
    setOpen,
    branchSelected,
    loading,
    getBranches,
    branches,
    deleteBranch,
    cleanDeleteBranch
}: DeleteBranchesProps) => {
    const toast = useToast();

    useEffect(() => {
        if(branches?.delete?.fetching === "failure"){
            toast("Ha ocurrido un error al eliminar la sucursal");
            cleanDeleteBranch();
        }
        if(branches?.delete?.fetching === "success"){
            toast(`Sucursal ${capitalize(branchSelected?.name)} eliminada correctamente`);
            setOpen(false)
            // Skip API calls for admin-brand users
            if(user?.profile?.code !== "admin-brand") {
                getBranches(user?.dealership, "dealership", "sellers");
            }
            cleanDeleteBranch();
        }
    }, [branches?.delete?.fetching]);

    return (
        <Modal open={open} variant="white" className={styles.modalDeleteBranch}>
            <p>
                <span className={styles.message}>Estás a punto de eliminar la siguiente sucursal</span>
                <span className={styles.name}>{capitalize(branchSelected?.name)}</span>
            </p>
            <div className={styles.buttons}>
                <ButtonShared 
                    onPress={() => setOpen(false)}
                    title="Regresar" 
                    tertiary
                    size="small"
                />
                <ButtonShared 
                    onPress={() => deleteBranch(branchSelected?._id)}
                    title="Eliminar" 
                    primary
                    size="small"
                    loading={loading}
                />
            </div>
        </Modal>
    )
};
export default Sidebar;